<template>
  <div class="info-block social-converter-block">
    <div class="title">Please specify who you are</div>
    <div class="choose-block">
      <div class="row">
        <div class="col-6">
          <div
            class="user-type-block"
            @click="setUserType(2)"
            :class="userType === 2 ? 'active' : ''"
          >
            <div class="user-type-title">Job seeker</div>
          </div>
        </div>
        <div class="col-6">
          <div
            class="user-type-block"
            @click="setUserType(1)"
            :class="userType === 1 ? 'active' : ''"
          >
            <div class="user-type-title">Employer</div>
            <div class="user-type-company">
              <label>Company name</label>
              <input name="company" class="form-control" v-model="company" />
              <div
                class="modal-block-form-error-set company-eror"
                v-if="showCompanyError && !company"
              >
                <div class="modal-block-form-error">
                  Please fill in company name
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-block-form-error-set" v-if="showError">
        <div class="modal-block-form-error">Please specify who you are</div>
      </div>
    </div>

    <div class="btn-set">
      <button type="submit" class="btn btn-primary blue" @click="saveUserType">
        Save changes
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SocialConverter',
  components: {},
  title: '',
  props: {},
  data() {
    return {
      userType: 3,
      company: '',
      showError: false,
      showCompanyError: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    setUserType(type) {
      this.userType = type
      this.showError = false
    },
    saveUserType() {
      if (this.userType && this.userType != 3) {
        if (this.userType == 1 && this.company == '') {
          this.showCompanyError = true
        } else {
          this.$store
            .dispatch('profile/setUserType', {
              type: this.userType,
              company: this.company
            })
            .then(response => {
              location.reload()
            })
        }
      } else {
        this.showError = true
      }
    }
  }
}
</script>
